export const messages = {
  title: 'Discover the NIO\nApp and become part of our community.',
  description: 'The NIO App connects you with our community, delivers exclusive content, brings you the latest news about NIO products and services and allows you to operate your future NIO vehicle.',
  downloadIos: 'Download for iOS',
  downloadAndroid: 'Download for Android'
}
